module.exports = __webpack_public_path__ + "static/media/blom-pysanky-sm-134.071b4263.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/blom-pysanky/blom-pysanky-sm-134.jpg
// module id = 3833
// module chunks = 14